import { render, staticRenderFns } from "./BitrixDealConfig.vue?vue&type=template&id=27688ba6&scoped=true&"
import script from "./BitrixDealConfig.vue?vue&type=script&lang=ts&"
export * from "./BitrixDealConfig.vue?vue&type=script&lang=ts&"
import style0 from "./BitrixDealConfig.vue?vue&type=style&index=0&id=27688ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27688ba6",
  null
  
)

export default component.exports